import { useSelector } from 'react-redux'
import { RootState } from '../index'
import { ChainType } from '../../constants/chains'

export function useChainType() {
  return useSelector<RootState, ChainType | undefined>(
    (state) => state.connect.chainType,
  )
}
